import React, { createContext } from "react";
import type { ReactNode } from "react";
import type { RootStoreInstance } from "./types";

// Create the store context with undefined default value
// Export it so useStores can access it from a separate file
export const StoreContext = createContext<RootStoreInstance | undefined>(undefined);

// StoreProvider component props
interface StoreProviderProps {
  store: RootStoreInstance;
  children: ReactNode;
}

/**
 * Provider component that makes the MST store available to child components.
 * Wraps children with the store context.
 */
export function StoreProvider({ store, children }: StoreProviderProps) {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}
